import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Text, Icon } from '@fluentui/react';
import theme from '../../../theme.style';

export default function Stepper({ number, disabled, isComplete, children }) {
  return (
    <Stack tokens={{ childrenGap: 14 }}>
      <Stack tokens={{ childrenGap: 6 }} horizontal verticalAlign="center">
        <span
          style={{
            padding: 4,
            backgroundColor: disabled ? 'gray' : theme.palette.accentTeal,
            borderRadius: '100%',
            flexShrink: 0,
            width: '1.25rem',
            height: '1.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text
            style={{
              color: 'white',
              fontSize: '0.75rem',
              fontWeight: 'normal',
            }}
          >
            {isComplete ? (
              <Icon
                style={{ width: '100%', height: '100%' }}
                iconName="StatusCircleCheckmark"
                color="white"
              />
            ) : (
              number
            )}
          </Text>
        </span>

        <span style={{ backgroundColor: 'gray', opacity: 0.5, height: 1, flexGrow: 1 }} />
      </Stack>

      {children}
    </Stack>
  );
}

Stepper.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};
